// Core
import React from 'react'
import PhoneInput from 'react-phone-input-2'

// Components
import InputWrapper from 'components/Onboarding/FormFields/InputWrapper'

// Types
interface ITelInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string
  suffix?: string
  errorMsg?: string | boolean
  dataCy: string
  setFieldValue: (field: string, value: any, shouldValidate?: boolean) => void
  country?: string
}

// inputClass does not work, so have to use inputStyle
const inputStyle = {
  height: '50px',
  lineHeight: '50px',
  fontFamily: 'Poppins, sans-serif',
  fontSize: '14px',
  width: '100%',
  border: '1px solid #E8E8E8',
  borderRadius: '4px',
  paddingBlock: '12px',
  background: '#F8F8F8',
  letterSpacing: '0.025em',
  '::placeholder': {
    color: '#A3A3A3',
  },
  ':disabled': {
    background: '#E8E8E8',
    opacity: 0.5,
  },
  '@media screen and (minWidth: 1921px)': {
    fontSize: '16px',
  },
}
const buttonStyle = { background: 'transparent', borderRight: 'none' }

const TelInput: React.FC<ITelInputProps> = ({
  label,
  suffix,
  name,
  value = '',
  placeholder,
  onChange,
  onBlur,
  errorMsg,
  dataCy,
  setFieldValue,
  country = 'gb',
}) => (
  <InputWrapper
    label={label}
    suffix={suffix}
    errorMsg={errorMsg}
    dataCy={`wrapper-${dataCy}`}
  >
    <div className="position-relative">
      <PhoneInput
        preferredCountries={['gb', 'us']}
        inputProps={{ name, 'data-cy': dataCy }}
        country={country}
        autocompleteSearch
        inputStyle={inputStyle}
        buttonStyle={buttonStyle}
        placeholder={placeholder}
        autoFormat={false}
        value={value.toString()}
        onChange={(phoneNumber, country) => {
          if ('dialCode' in country && country.dialCode) {
            setFieldValue(name || 'phoneNumber', phoneNumber, true)
            setFieldValue('countryId', parseInt(country.dialCode))

            // Create a fake event to pass to onChange
            const fakeEvent = {
              target: { name, value: phoneNumber },
            } as React.ChangeEvent<HTMLInputElement>

            if (onChange) {
              onChange(fakeEvent)
            }
          }
        }}
        onBlur={onBlur}
      />
    </div>
  </InputWrapper>
)

export default TelInput
